import { render, staticRenderFns } from "./partnership.vue?vue&type=template&id=e2c3cd9c&scoped=true"
import script from "./partnership.vue?vue&type=script&lang=js"
export * from "./partnership.vue?vue&type=script&lang=js"
import style0 from "./partnership.vue?vue&type=style&index=0&id=e2c3cd9c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c3cd9c",
  null
  
)

export default component.exports